import * as React from 'react';

function SvgInfoFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
      <path
        fill="#000"
        fillOpacity={0.54}
        d="M7 .333A6.67 6.67 0 00.333 7 6.67 6.67 0 007 13.667 6.67 6.67 0 0013.667 7 6.67 6.67 0 007 .333zm0 10a.669.669 0 01-.667-.666V7c0-.367.3-.667.667-.667.367 0 .667.3.667.667v2.667c0 .366-.3.666-.667.666zM7.667 5H6.333V3.667h1.334V5z"
      />
    </svg>
  );
}

export default SvgInfoFilled;
